module.exports = __webpack_public_path__ + "static/media/digita-logo-white.753201a9.svg";